/* Stock-aware product cards.

   Shared by the two card templates: snippets/product-card.liquid (collection
   pages) and sections/jaf-product-grid.liquid (homepage). Both resolve a
   variant id when a size is clicked, but neither reads variant.available and
   neither touches the add button. The result was a live "ADD TO CART" on
   sold-out variants -- the collection card surfaced a 422 "already sold out"
   toast, and the homepage card silently redirected the shopper to /cart.

   This reads whichever variant payload the card rendered -- [data-card-variants]
   (compact, collection cards) or [data-product-json] (full product, homepage) --
   and keeps the button honest. It runs alongside the existing handlers rather
   than replacing them: both set the same .is-active class and the same id. */
(function () {
  'use strict';

  function variantsFor(card) {
    var el = card.querySelector('[data-card-variants]') || card.querySelector('[data-product-json]');
    if (!el) return null;

    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : parsed.variants;
    } catch (err) {
      console.error('Could not parse card variant data:', err);
      return null;
    }
  }

  function selectionFor(card) {
    var sel = {};
    card.querySelectorAll('.jaf-card__swatch.is-active, .jaf-card__size.is-active').forEach(function (btn) {
      if (btn.dataset.optionIndex && btn.dataset.optionValue) {
        sel[btn.dataset.optionIndex] = btn.dataset.optionValue;
      }
    });
    return sel;
  }

  function match(variants, sel) {
    return variants.find(function (variant) {
      return Object.keys(sel).every(function (pos) {
        return variant.options[Number(pos) - 1] === sel[pos];
      });
    });
  }

  function sync(card, autoSelect) {
    var variants = variantsFor(card);
    if (!variants || !variants.length) return;

    var form = card.querySelector('.jaf-card-form');
    if (!form) return;

    var hidden = form.querySelector('[data-variant-id], [name="id"]');
    var addBtn = form.querySelector('.jaf-card__add');
    var sel = selectionFor(card);

    /* Both templates mark the FIRST size active regardless of stock, so a
       product whose first size is gone looked sold out. On the initial pass,
       move to the first purchasable size the way Liquid's
       selected_or_first_available_variant does. Never on a user click -- if
       someone picks a sold-out size, they should see SOLD OUT. */
    if (autoSelect) {
      var current = match(variants, sel);

      if (!current || !current.available) {
        var sizes = Array.prototype.slice.call(card.querySelectorAll('.jaf-card__size'));

        for (var i = 0; i < sizes.length; i++) {
          if (!sizes[i].dataset.optionIndex || !sizes[i].dataset.optionValue) continue;

          var probe = Object.assign({}, sel);
          probe[sizes[i].dataset.optionIndex] = sizes[i].dataset.optionValue;
          var candidate = match(variants, probe);

          if (candidate && candidate.available) {
            sizes.forEach(function (b) { b.classList.remove('is-active'); });
            sizes[i].classList.add('is-active');
            sel = selectionFor(card);
            break;
          }
        }
      }
    }

    // Strike through any size with no purchasable variant under the current colour.
    card.querySelectorAll('.jaf-card__size').forEach(function (btn) {
      var probe = Object.assign({}, sel);
      if (btn.dataset.optionIndex && btn.dataset.optionValue) {
        probe[btn.dataset.optionIndex] = btn.dataset.optionValue;
      }
      var found = match(variants, probe);
      btn.classList.toggle('is-unavailable', !(found && found.available));
    });

    var variant = match(variants, sel);
    if (hidden && variant) hidden.value = variant.id;
    if (!addBtn) return;

    var label = addBtn.querySelector('span');
    var plus = addBtn.querySelector('.jaf-card__add-plus');
    var purchasable = !!(variant && variant.available);

    addBtn.disabled = !purchasable;
    if (label) label.textContent = purchasable ? 'ADD TO CART' : (variant ? 'SOLD OUT' : 'UNAVAILABLE');
    if (plus) plus.hidden = !purchasable;
  }

  function syncAll(context) {
    (context || document).querySelectorAll('[data-product-card]').forEach(function (card) {
      sync(card, true);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jaf-card__size, .jaf-card__swatch');
    if (!btn) return;

    var card = btn.closest('[data-product-card]');
    if (!card) return;

    var group = btn.classList.contains('jaf-card__swatch') ? '.jaf-card__swatch' : '.jaf-card__size';
    card.querySelectorAll(group).forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    sync(card, false);
  });

  document.addEventListener('shopify:section:load', function (e) { syncAll(e.target); });

  window.JAFCardStockSync = syncAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAll(); });
  } else {
    syncAll();
  }
})();
